import React from "react";
import "./Integrations.css";

import Recharge from "../../assets/images/Lp/recharge.png";
import Shipstation from "../../assets/images/Lp/shipstation.png";

const Box_data = [
  {
    id: 1,
    img: Shipstation,
    title: "Shipstation",
    desc: "Any order will be canceled in Shipstation as well",
  },
  {
    id: 2,
    img: Recharge,
    title: "Recharge",
    desc: "Any canceled subscription order will also cancel the subscription in Recharge",
  },
];
export default function Integrations({ id }) {
  return (
    <div id={id} className="section py-constant">
      <div className="container">
        <h2 className="h2 title center">Integrations</h2>
        <div className="flex flex-row boxes">
          {Box_data.map((item) => {
            return (
              <div className="box-wrap">
                <img src={item.img} width={60} alt="" className="image" />

                <div className="dt">
                  <div className="hd">{item.title}</div>
                  <div
                    className="text-md"
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
